import {FETCH_PUSH_NOTIFICATIONS} from "../../actions/types";


const INITIAL_STATE = {
    number: 0,
    content: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_PUSH_NOTIFICATIONS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/brands/AppNotificationReducer.js